import { FunctionComponent } from "react"
import { useRouter } from "next/router"

import Pencil from "@/assets/icons/pencil.svg"
import DirectionIcon from "@/assets/icons/direction.svg"
import Arrow from "@/assets/icons/arrow.svg"

import styles from "./styles.module.scss"

interface DirectionProps {
  date: string
  from: string
  to: string
}

const Direction: FunctionComponent<DirectionProps> = ({ date, from, to }) => {
  const router = useRouter()
  const url = Boolean(router.query.slug) ? "/order/location" : ""
  const query = new URLSearchParams(
    router.query as Record<string, string>
  ).toString()
  const href = `${url}/?${query}`

  return (
    <>
      <div className={styles.direction__mobile}>
        <p className={styles.direction__date}>
          {date.split(" ")[0]} at {date.split(" ")[1]}
          <a href={href} className={styles.direction__edit}>
            <Pencil className={styles.direction__pencil} />
          </a>
        </p>
        <div className={styles.direction}>
          <DirectionIcon className={styles.direction__icon} />
          <p>{from}</p>
          <p>{to}</p>
        </div>
      </div>
      <div className={styles.direction__desktop}>
        <div className={styles.direction__row}>
          <div className={styles.direction__pickup}>
            <p className={styles.direction__label}>Pick up location</p>
            <p className={styles.direction__text} title={from}>
              {from}
            </p>
          </div>
          <Arrow className={styles.direction__arrow} />
          <div className={styles.direction__destination}>
            <p className={styles.direction__label}>Destination</p>
            <p className={styles.direction__text} title={to}>
              {to}
            </p>
          </div>
          <div className={styles.direction__divider} />
          <div>
            <p className={styles.direction__label}>Date</p>
            <p className={styles.direction__text}>{date.split(" ")[0]}</p>
          </div>
          <div className={styles.direction__divider} />
          <div>
            <p className={styles.direction__label}>Time</p>
            <p className={styles.direction__text}>{date.split(" ")[1]}</p>
          </div>
        </div>
        <a href={href} className={styles.direction__edit}>
          Revise Pickup & Destination
        </a>
      </div>
    </>
  )
}

export default Direction
